module.exports = __webpack_public_path__ + "static/media/avenir-next-regular.6377ae19.eot";